import Vue from "vue";
import VueRouter from "vue-router";

import QuestionnaireComponent from "./components/Questionnaire.vue";
import CertificateComponent from "./components/Certificate.vue";

Vue.use(VueRouter);

export function createRouter({ questionnaires }) {
  return new VueRouter({
    mode: "history",
    routes: [
      { path: "/", component: require("./components/Homepage.vue").default },
      ...questionnaires.flatMap(({ identifier }) => [
        {
          path: `/${identifier}`,
          component: QuestionnaireComponent,
          props: () => ({ identifier }),
        },
        {
          path: `/${identifier}/certificate`,
          component: CertificateComponent,
          props: () => ({ identifier }),
        },
      ]),
      { path: "*", component: require("./components/NotFound.vue").default },
    ],
  });
}
